/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Card, CardBody, Icon, Button } from '@wordpress/components';

const NoBlockTheme = () => {
	return <>
		<Card>
			<CardBody>
				<div className="gutenify--template-kit-browser--no-theme">
					<Icon icon="warning" />
					<h3>{ __( 'Current Theme is not supported for Template Kit. Please download supported theme.' ) }</h3>
					<Button href="https://gutenify.com/themes/" isPrimary><Icon icon="welcome-view-site" /> &nbsp; { __( 'Browse Supported Themes' ) } </Button>
				</div>
			</CardBody>
		</Card>
	</>;
};
export default NoBlockTheme;
